import React, {useEffect, useState} from "react";
import {collection, doc, getDocs, orderBy, query, where} from "firebase/firestore";
import {httpsCallable} from "firebase/functions"
import {auth, db, functions} from "../../configs/firebase-config";
import ButtonPrimary from "../../components/Button/ButtonPrimary";


const DashboardSubscription = () => {
    const [name, setName] = useState("");
    const [billing, setBilling] = useState("");
    const [renew, setRenew] = useState("");

    const postDocRef = doc(db, "users", `${auth.currentUser?.uid}`);
    const subsCollectionRef = collection(postDocRef, "subscriptions");

    const data = [
        {name: "Subscription Tier", content: name},
        {name: "Package Cost", content: billing},
        {name: "Renewal Date", content: renew},
    ];

    useEffect(() => {
        getDocs(query(subsCollectionRef, where("status", "==", "active"), orderBy("created", "desc"))).then((snapshot) => {
            if (snapshot.empty) return;
            snapshot.forEach((result) => {
                setName(result.get("role"));
                setRenew(result.get("current_period_end").toDate().toDateString());
                setBilling(`£${(result.data().items[0].plan.amount / 100)}`);
            })
        })
    }, [])

    const manageSubscription = async () => {
        const customerPortal = httpsCallable(functions, "ext-firestore-stripe-payments-createPortalLink");
        const {data} = await customerPortal({
            returnUrl: window.location.origin,
            locale: "auto", // Optional, defaults to "auto"
            // configuration: "bpc_1JSEAKHYgolSBA358VNoc2Hs", // Optional ID of a portal configuration: https://stripe.com/docs/api/customer_portal/configuration
        })
        // @ts-ignore
        window.location.assign(data.url);
    }
    return (
        <div
            className="bg-white dark:bg-neutral-900 dark:border dark:border-neutral-800 shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg leading-6 font-medium text-neutral-900 dark:text-neutral-200">
                    Subscription Information
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-neutral-500 dark:text-neutral-400">
                    Manage your subscription level and billing details
                </p>

            </div>
            <div className="relative border-t border-neutral-200 dark:border-neutral-900">
                <dl>
                    {data.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`${
                                    index % 2 === 0
                                        ? "bg-neutral-50 dark:bg-neutral-800"
                                        : "bg-white dark:bg-neutral-900"
                                } px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6`}
                            >
                                <dt className="text-sm font-medium text-neutral-500 dark:text-neutral-300">
                                    {item.name}
                                </dt>
                                <dd className="mt-1 text-sm text-neutral-900 dark:text-neutral-200 font-medium sm:mt-0 sm:col-span-2">
                                    {item.content}
                                </dd>
                            </div>
                        );
                    })}
                </dl>
            </div>
            <div className=" md:border-neutral-100 dark:border-neutral-800 md:p-6">
                <div className="grid md:grid-cols-2 gap-6">
                    <ButtonPrimary className="md:col-span-2" onClick={manageSubscription}>Manage
                        Subscription</ButtonPrimary>
                </div>
            </div>
        </div>
    );
};

export default DashboardSubscription;
